import { Box, Flex, SystemProps } from '@chakra-ui/react'

import BigSwitch from 'src/components/widgets/BigSwitch/BigSwitch'

const LockSwitch: React.FC<
  {
    locked: boolean
    setLocked: (locked: boolean) => void
  } & SystemProps
> = ({ locked, setLocked, ...props }) => (
  <Flex
    px={4}
    alignItems="center"
    justifyContent="center"
    direction="column"
    pt={4}
    {...props}
  >
    <BigSwitch
      leftLabel="Pre-Sale"
      rightLabel="Purchased"
      value={locked}
      setValue={setLocked}
    />
    <Box className="body-extra-small-emphasis" color="graphite" my={3}>
      {locked
        ? 'What someone sees before buying or saving your ItList.'
        : 'What someone sees after buying or saving your ItList.'}
    </Box>
  </Flex>
)

export default LockSwitch
